export default __webpack_public_path__ + "static/media/windows.1ba2169ab718ea1a4bf748e7b9cd88cd.svg";